ALLOWED_CONTROLLER = 'people'
ALLOWED_ACTIONS = ['index']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)
  peopleTable = $('#people').dataTable
    sPaginationType: "full_numbers"
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    iDisplayLength: 50
    sAjaxSource: $('#people').data('source')
    fnServerData: (sSource, aoData, fnCallback) ->
      $.getJSON(sSource, aoData, (data) ->
        if ('errors' of data)
          for error in data['errors']
            $('#flash').append('<div class="alert">' + error + '</div>')
          data.data = []
        fnCallback(data)
      )
    order: [ [ 0, "desc" ] ]
    aoColumnDefs:
      [ { 'bSortable': false, 'aTargets': [ 6 ] } ]
    oSearch: {"sSearch": URLParam('search_terms')}
    fnServerData: _.debounce((sSource, aoData, fnCallback, oSettings) ->
      $.ajax
        dataType: 'json'
        type: 'GET'
        url: sSource
        data: aoData
        success: fnCallback
    , 1200)
  peopleTable.on('search.dt', () ->
      $('#flash').html('')
  )

$(document).ready(ready)


URLParam = (param) ->
  pageURL = window.location.search.substring(1)
  URLVariables = pageURL.split('&')
  for variable in URLVariables
    parameterName = variable.split('=')
    if parameterName[0] == param
      return decodeURIComponent(parameterName[1].replace(/\+/g, ' '))
